import { SaveOutlined } from '@mui/icons-material'
import { Box, Button, Divider, Typography } from '@mui/material'
import InCardStack from 'components/atoms/container/InCardStack'
import RequestRetryAlert from 'components/atoms/RequestRetryAlert'
import { PageHeader } from 'components/atoms/Text'
import RichTextContentEditor from './RichTextEditor'

const SourceEditor = ({
  sources,
  setSources,
  initialSources = '',
  saved,
  requestError,
  handleSave,
  sourcesEditorCallback,
  handleClearSource = () => {}
}) => {
  const SaveButton = props => (
    <Button
      {...props}
      onClick={() => handleSave()}
      disabled={saved}
      size='small'
      startIcon={<SaveOutlined />}>
      Save
    </Button>
  )

  return (
    <>
      {sources ? (
        <>
          <Divider width='100%' />
          <InCardStack direction='row'>
            <PageHeader>Sources Editor</PageHeader>
            <SaveButton />
          </InCardStack>
          {requestError ? <RequestRetryAlert /> : null}
          <RichTextContentEditor
            data={initialSources}
            changeCallback={sourcesEditorCallback}
          />
          <Typography variant='h4'>Sources Preview</Typography>
          <Box
            dangerouslySetInnerHTML={{ __html: sources }}
            className='journeyStepContentInnerHTML'
          />
          <InCardStack direction='row'>
            <SaveButton />
            <Button size='small' onClick={() => handleClearSource()}>
              Remove Sources
            </Button>
          </InCardStack>
        </>
      ) : (
        <Button onClick={() => setSources('<p></p>')}>Add Sources</Button>
      )}
    </>
  )
}

export default SourceEditor
